export const alertTypeConfig = {
  error: {
    icon: 'DangerAlertIcon',
    color: 'danger'
  },
  success: {
    color: 'success',
    icon: 'SuccessAlertIcon'
  },
  warning: {
    color: 'warning',
    icon: 'WarningAlertIcon'
  },
  info: {
    color: 'info',
    icon: 'PrimaryAlertIcon'
  },
  smallPrimary: {
    color: 'primary',
    small: true
  },
  smallSecondary: {
    color: 'secondary',
    small: true
  },
  smallSuccess: {
    color: 'success',
    small: true
  },
  smallError: {
    color: 'danger',
    small: true
  },
  smallWarning: {
    color: 'warning',
    small: true
  },
  smallInfo: {
    color: 'info',
    small: true
  }
}
